var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Transition',{attrs:{"name":"fade"}},[(_vm.notifications.length)?_c('div',{staticClass:"notifications",class:{ 'super-admin': _vm.isSuperAdmin || _vm.actingAs }},_vm._l((_vm.notifications),function(notification,index){return _c('Notification',{key:`notification-${index}`,attrs:{"notification":notification}})}),1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }